import React from "react";
import { Link } from "react-router";
import { Celebration } from "../calendar/ordinariate-calendar";
import { CalendarDay } from "../calendar/utils";
import { RUBRIC_COLOR } from "../tokens";
import { LoadableDataDependency } from "../utils/RemoteDataProvider";
import { useCalcheck } from "./calcheck-utils";

export const CalCheckLine: React.FC<{
    day: CalendarDay;
    celebration: Celebration;
    hour: "first-evensong" | "mattins" | "second-evensong";
    loadableTextList: LoadableDataDependency<string[]>;
}> = (props) => {
    const { day, celebration, hour, loadableTextList } = props;

    const { loadableTextIsMissing, valueIsMissing } =
        useCalcheck(loadableTextList);

    return (
        <div
            style={{
                paddingBottom: 8,
                display: "flex",
                flexDirection: "row",
                gap: 16,
            }}
        >
            <div>
                <strong>
                    {celebration.regionNote
                        ? `${celebration.regionNote}: `
                        : ""}
                    {celebration.title}
                    {hour === "first-evensong" ? ` (Eve)` : ""}
                </strong>{" "}
                — {celebration.type} {celebration.rank}
            </div>
            <Link
                to={`se/${day.year}/${day.month}/${day.date}/${celebration.label}/${hour}`}
                style={{
                    color: RUBRIC_COLOR,
                }}
            >
                Open
            </Link>
            {celebration.collect ? undefined : <div>❌ No collect</div>}
            {loadableTextList.state === "loaded" ? (
                <>
                    {hour === "first-evensong" &&
                    loadableTextIsMissing(
                        day,
                        celebration,
                        "ep1HymnId",
                        false
                    ) ? (
                        <div>❌ No EP1 hymn</div>
                    ) : (
                        <></>
                    )}
                    {hour === "first-evensong" &&
                    valueIsMissing(day, celebration, "ep1VandR") ? (
                        <div>❌ No EP1 V&amp;R</div>
                    ) : (
                        <></>
                    )}
                    {hour === "first-evensong" &&
                    loadableTextIsMissing(
                        day,
                        celebration,
                        "ep1MagId",
                        true
                    ) ? (
                        <div>❌ No EP1 Mag</div>
                    ) : (
                        <></>
                    )}
                    {hour === "mattins" &&
                    loadableTextIsMissing(day, celebration, "invId", true) ? (
                        <div>❌ No Inv</div>
                    ) : (
                        <></>
                    )}
                    {hour === "mattins" &&
                    loadableTextIsMissing(
                        day,
                        celebration,
                        "mpHymnId",
                        false
                    ) ? (
                        <div>❌ No MP hymn</div>
                    ) : (
                        <></>
                    )}
                    {hour === "mattins" &&
                    valueIsMissing(day, celebration, "mpVandR") ? (
                        <div>❌ No MP V&amp;R</div>
                    ) : (
                        <></>
                    )}
                    {hour === "mattins" &&
                    loadableTextIsMissing(day, celebration, "mpBenId", true) ? (
                        <div>❌ No Ben</div>
                    ) : (
                        <></>
                    )}
                    {hour === "second-evensong" &&
                    loadableTextIsMissing(
                        day,
                        celebration,
                        "ep2HymnId",
                        false
                    ) ? (
                        <div>❌ No EP2 hymn</div>
                    ) : (
                        <></>
                    )}
                    {hour === "second-evensong" &&
                    valueIsMissing(day, celebration, "ep2VandR") ? (
                        <div>❌ No EP2 V&amp;R</div>
                    ) : (
                        <></>
                    )}
                    {hour === "second-evensong" &&
                    loadableTextIsMissing(
                        day,
                        celebration,
                        "ep2MagId",
                        true
                    ) ? (
                        <div>❌ No EP2 Mag</div>
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <>⌛</>
            )}
        </div>
    );
};
